import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

import { InputWithSearch } from "components/common/InputWithSearch";
import { Typography } from "new-components/typography/Typography";


const filterOptions = [
  {
    name: "Best to Worst",
    value: "BEST",
  },
  {
    name: "Worst to Best",
    value: "WORST",
  },
];

interface FiltersSectionProps {
  filters: Record<string, string>;
  setFilters: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

export function FiltersSection(props: FiltersSectionProps) {
  const { filters, setFilters } = props;

  const handleChangeFilters = (key: string, value: string) => {
    setFilters({ ...filters, [key]: value });
  };

  return (
    <Box className="flex flex-col sm:flex-row justify-between w-full gap-6 bg-white py-2 px-4 rounded-md">
      <Box className="w-full sm:w-[25%]">
        <InputWithSearch
          defaultValueSearch={filters.detectors_search || ""}
          handleChangeSearchText={(value) => handleChangeFilters("detectors_search", value)}
          textFieldProps={{
            placeholder: "Search by detector",
          }}
        />
      </Box>

      <Box className="w-full sm:w-[25%]">
        <InputWithSearch
          defaultValueSearch={filters.labelers_search || ""}
          handleChangeSearchText={(value) => handleChangeFilters("labelers_search", value)}
          textFieldProps={{
            placeholder: "Search by labeler",
          }}
        />
      </Box>

      <Box className="w-full sm:w-[50%] flex items-center gap-4">
        <Typography variant="detail" fontWeight="semibold" className="text-[#006DD9]" noWrap>
          Sort by:
        </Typography>

        <FormControl size="small" fullWidth>
          <InputLabel id="demo-simple-select-label">Detectors</InputLabel>
          <Select
            id="demo-simple-answer-select"
            value={filters.detectors_sort}
            onChange={(e) => handleChangeFilters("detectors_sort", e.target.value)}
            fullWidth
            label="Detectors"
            className="pl-1"
            sx={{
              ".MuiSelect-outlined": { paddingX: "2px" },
            }}
          >
            {filterOptions.map((option: any) => (
              <MenuItem value={option.value} key={option.value} data-testid="btn-option">
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel id="demo-simple-select-label">Labelers</InputLabel>
          <Select
            id="demo-simple-answer-select"
            value={filters.labelers_sort}
            onChange={(e) => handleChangeFilters("labelers_sort", e.target.value)}
            fullWidth
            label="Labelers"
            className="pl-1"
            sx={{
              ".MuiSelect-outlined": { paddingX: "2px" },
            }}
          >
            {filterOptions.map((option: any) => (
              <MenuItem value={option.value} key={option.value} data-testid="btn-option">
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}

export default FiltersSection;
